import { WeightChart } from './WeightChart.ts';

document.addEventListener('DOMContentLoaded', () => {
    const chartWrappers = document.querySelectorAll('[data-chart-role="container"][data-chart-type="weight-chart"]');

    chartWrappers.forEach(wrapper => {
        const initializeChart = async () => {
            const chartArea = wrapper.querySelector('[data-chart-role="chart-area"]');
            const controlsContainer = wrapper.querySelector('[data-chart-role="controls"]');

            if (!chartArea) {
                console.error('[weight-chart] Error: Chart area (role="chart-area") not found.');
                return;
            }
            if (chartArea._chartInstance) return;

            const chart = new WeightChart(chartArea, {});
            chartArea._chartInstance = chart;

            try {
                await chart.init();

                if (controlsContainer) {
                    let userHasInteracted = false;
                    const handleUserInteraction = () => {
                        if (!userHasInteracted) {
                            userHasInteracted = true;
                            chart.config.autoplay = false;
                        }
                    };
                    
                    // 年号表示を含むUIを動的生成
                    controlsContainer.innerHTML = `
                        <button class="play-pause-button" aria-label="再生/一時停止"></button>
                        <input type="range" class="time-slider" min="0" max="0" value="0" step="1" aria-label="アニメーションのスライダー">
                        <span class="current-year-display"></span>
                    `;

                    const playPauseButton = controlsContainer.querySelector('.play-pause-button');
                    const slider = controlsContainer.querySelector('.time-slider');
                    const yearDisplay = controlsContainer.querySelector('.current-year-display');

                    if (playPauseButton) playPauseButton.addEventListener('click', () => { handleUserInteraction(); chart.togglePlayPause(); });
                    if (slider) slider.addEventListener('input', () => { handleUserInteraction(); chart.seek(parseInt(slider.value, 10)); });
                    
                    chart.onUpdateUI(state => {
                        wrapper.classList.toggle('is-playing', state.isPlaying);
                        if (slider) {
                            const totalFrames = state.totalFrames > 0 ? state.totalFrames - 1 : 0;
                            if (slider.max != totalFrames) slider.max = totalFrames;
                            slider.value = state.currentFrame;
                        }
                        if (yearDisplay) {
                            yearDisplay.textContent = state.currentYear || '';
                        }
                    });
                } else {
                    console.warn('[weight-chart] Warning: Controls container (role="controls") not found.');
                }
            } catch (error) {
                console.error('[weight-chart] Initialization failed:', error);
            }
        };
        initializeChart();
    });
});